import * as React from 'react';
import * as toastr from 'toastr';
import IconWithText from '../../services/Shared/IconWithText/IconWithText';
import RenderSwal from '../../services/Shared/RenderSwal/RenderSwal';
import StaticSingleton from '../../services/Shared/StaticSingleton';
import { IAuthorizer } from './IAuthorizer';
import { ReloadApp } from '../../presentation/App';

class LocalStorageAuthorizer extends StaticSingleton<LocalStorageAuthorizer> implements IAuthorizer {
	IsSignedIn() {
		return this.GetUserName() !== '';
	}

	GetUserName() {
		return localStorage.getItem('username') || '';
	}

	SignIn(username: string) {
		localStorage.setItem('username', username);
		ReloadApp();
	}
}

export default new LocalStorageAuthorizer();

export const localStorage_key_token = `token`;
